// ログアウトのたびに進む世代カウンタ。非同期処理は開始時のエポックを捕捉しておき、
// 副作用を起こす直前に isSessionEpochCurrent で「その間にログアウトされていないか」を確認する
let currentEpoch = 0;

export const getSessionEpoch = (): number => currentEpoch;

export const advanceSessionEpoch = (): void => {
  currentEpoch += 1;
};

export const isSessionEpochCurrent = (epoch: number): boolean =>
  epoch === currentEpoch;

export const __resetSessionEpochForTest = (): void => {
  currentEpoch = 0;
};
